import { Component, OnInit } from '@angular/core';
import { ReleaseVersionService } from 'app/Shared/Services/release-version.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    imports: [],
    providers: [],
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  currentYear: any;
  constructor(public releaseVersionService:ReleaseVersionService) { }

  ngOnInit() {
    this.currentYear = new Date().getFullYear();
  }

}
